import _ from 'lodash';

export function snakeCase (val) {
	if(/[A-zÀ-ÿ]\+/.test(val)){
		val = val.replace(/([A-zÀ-ÿ])\+/ig, '$1_plus')
	}
	return _.snakeCase(val);
}